import { Box, type BoxProps, useTheme } from '@mui/material';
import type { FC } from 'react';

export const SlabCardHeader: FC<BoxProps> = ({ children, sx, ...props }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: 1,
        gap: 1,
        display: 'flex',
        backgroundColor: theme.palette.SlabGray['50'],
        padding: 2,
        flex: 1,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
